import { LOG_IN_USER, FETCH_USER, LOG_OUT_USER } from '../../actions/actionTypes';

const userReducer = (state={}, action) => {
    let user = state;
    if (action.errors == null){
        switch(action.type){
            case LOG_IN_USER:
                return {
                    ...action.payload.user,
                    userId: action.payload.user.pk
                };
            case FETCH_USER:
                return action.payload.user;
            case LOG_OUT_USER:
                return {}
        }
    }
    return user;
}

export default userReducer;